/* Ivii Unlimited — base theme behavior:
   mobile nav, cart drawer (AJAX Cart API), scroll reveal. */

document.addEventListener('DOMContentLoaded', function () {
  initNavToggle();
  initCartDrawer();
  initReveal();
  initAddToCartForms();
});

function initNavToggle() {
  var toggle = document.querySelector('[data-nav-toggle]');
  if (!toggle) return;
  toggle.addEventListener('click', function () {
    document.body.classList.toggle('nav-open');
  });
}

function initReveal() {
  var items = document.querySelectorAll('[data-reveal]');
  if (!items.length) return;
  if (!('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  items.forEach(function (el) { observer.observe(el); });
}

/* ---------------- Cart drawer ---------------- */

function initCartDrawer() {
  var openTriggers = document.querySelectorAll('[data-cart-open]');
  var closeTriggers = document.querySelectorAll('[data-cart-close]');
  var lastFocus = null;

  function openCart() {
    lastFocus = document.activeElement;
    document.body.classList.add('cart-open');
    var closeBtn = document.querySelector('.cart-drawer__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeCart() {
    if (!document.body.classList.contains('cart-open')) return;
    document.body.classList.remove('cart-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  openTriggers.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openCart();
    });
  });
  closeTriggers.forEach(function (btn) {
    btn.addEventListener('click', closeCart);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });
}

function refreshCartDrawer() {
  var body = document.querySelector('[data-cart-drawer-body]');
  var footer = document.querySelector('[data-cart-drawer-footer]');
  var countEls = document.querySelectorAll('[data-cart-count]');
  if (!body) return;

  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      countEls.forEach(function (el) { el.textContent = cart.item_count; });

      if (!cart.items.length) {
        body.innerHTML = '<div class="cart-empty"><p>Your bag is empty.</p></div>';
        if (footer) footer.innerHTML = '';
        return;
      }

      body.innerHTML = cart.items.map(function (item) {
        var props = '';
        if (item.properties) {
          var entries = Object.keys(item.properties)
            .filter(function (k) { return item.properties[k] && k.indexOf('_') !== 0; })
            .map(function (k) { return k + ': ' + item.properties[k]; });
          if (entries.length) props = '<div class="cart-line__props">' + entries.join(' &middot; ') + '</div>';
        }
        return (
          '<div class="cart-line">' +
            '<img src="' + (item.image || '') + '" alt="" loading="lazy">' +
            '<div>' +
              '<div class="cart-line__title">' + item.product_title + '</div>' +
              props +
              '<div class="cart-line__price">' + (item.quantity) + ' &times; ' + formatMoney(item.price) + '</div>' +
            '</div>' +
          '</div>'
        );
      }).join('');

      if (footer) {
        footer.innerHTML =
          '<div class="summary-row total"><span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
          '<a href="/checkout" class="btn btn--dark btn--block" style="margin-top:16px;">Checkout</a>';
      }
    })
    .catch(function () { /* silent: cart state remains as last rendered */ });
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

function initAddToCartForms() {
  var forms = document.querySelectorAll('form[data-add-to-cart-form]');
  forms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.originalText = submitBtn.textContent; submitBtn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          refreshCartDrawer();
          document.body.classList.add('cart-open');
        })
        .catch(function (err) {
          alert((err && err.description) || 'Could not add this item to your bag.');
        })
        .finally(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.originalText; }
        });
    });
  });
}

window.iviiRefreshCartDrawer = refreshCartDrawer;
